import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import styles from "./CheckIssuesPage.module.css";

import { useAccount } from "../utils/AccountInfoContext";

export function CheckIssuesPage() {
  const history = useHistory();
  const { issuesData, nagScreenData, privacyData, consentData, checksLoading } =
    useAccount();

  useEffect(() => {
    let prevUrl = document.referrer;
    sessionStorage.setItem("prevUrl", prevUrl);

    if (!checksLoading) {
      // Check if any issue includes the term "unverified"
      let hasUnverifiedIssue = issuesData?.some(
        (issue) =>
          issue?.Type === "email-unverified" ||
          issue?.Type === "phone-unverified"
      );

      if (consentData && privacyData && privacyData.agreedLatest === false) {
        history.push("/tc");
      } else if (nagScreenData && nagScreenData.length > 0) {
        history.push("/sub-entity-alert");
      } else if (hasUnverifiedIssue) {
        history.push("/verify");
      } else if (
        consentData &&
        consentData.consent_provided &&
        consentData.consent_provided.toLowerCase() === "no"
      ) {
        history.push("/consent");
      } else if (
        prevUrl &&
        !prevUrl.includes("settings") &&
        !prevUrl.includes("https://apps-dev.wwdb.com/") &&
        !prevUrl.includes("https://apps-staging.wwdb.com/") &&
        !prevUrl.includes("https://www.wwdb.com/")
      ) {
        window.location.assign(prevUrl);
      } else {
        history.push("/");
      }
    }
  }, [consentData, nagScreenData, privacyData, issuesData, checksLoading]);

  return <div className={styles.container}></div>;
}

export default CheckIssuesPage;
